import './components/index.less'
import ycloud from './components'
window.ycloud = ycloud
export default ycloud



// WEBPACK FOOTER //
// ./src/index.js